import * as React from 'react';

import DialogMensualidadesAlert from './SubComponents/DialogMensualidadesAlert';
import Vehiculos from './Options/Vehiculos';
import Guia from './Options/Guia';
import Clientes from './Options/Clientes';
import Estadias from './Options/Estadias';
import Tarifas from './Options/Tarifas';
import Mensualidades from './Options/Mensualidades'
import Usuarios from './Options/Usuarios';
import Caja from './Options/Caja';

const Reportes = React.lazy(() => import('./Options/Reportes'));

const ContainerOptions = ({ option, handleChangeOption, handleCloseDialogMensualidades, openDialongMensualidades, handleSeeNotification, notifications, onDiscardNotification, notificationError, placaVehiculoCodigoDeBarras, createdTarget, onCreatedRecord, onCreatedTargetConsumed }) => {
    return (
      <>
        <DialogMensualidadesAlert handleCloseDialogMensualidades={handleCloseDialogMensualidades} openDialongMensualidades={openDialongMensualidades} handleSeeNotification={handleSeeNotification} notifications={notifications} onDiscardNotification={onDiscardNotification} notificationError={notificationError}/>

        {option === 'Vehiculos' ? (
          <Vehiculos handleChangeOption={handleChangeOption} placaVehiculoCodigoDeBarras={placaVehiculoCodigoDeBarras} onCreatedRecord={onCreatedRecord}/>
        ) : option === 'Guia' ? (
          <Guia handleChangeOption={handleChangeOption}/>
        ) : option === 'Clientes' ? (
          <Clientes/>
        ) : option === 'Estadias' ? (
          <Estadias createdTarget={createdTarget} onCreatedTargetConsumed={onCreatedTargetConsumed}/>
        ) : option === 'Tarifas' ? (
          <Tarifas/>
        ) : option === 'Mensualidades' ? (
          <Mensualidades createdTarget={createdTarget} onCreatedTargetConsumed={onCreatedTargetConsumed} />
        ) : option === 'Usuarios' ? (
          <Usuarios/>
        ) : option === 'Caja' ? (
          <Caja/>
        ) : option === 'Reportes' ? (
          <React.Suspense fallback={<div>Cargando...</div>}>
            <Reportes/>
          </React.Suspense>
        ) : (
          <div>No se encontró {option}</div>
        )}
      </>
    );
};

export default ContainerOptions;
